module.exports = __webpack_public_path__ + "img/1494064567.c8ea7cb5.jpg";